import "./App.css";

function App() {
  var currentQuestion = 0;
  var answer1, answer2, answer3;

  function submitAnswer(numb) {
    var questionNumber = numb;

    if (questionNumber == "1") {
      console.log(questionNumber);
      answer1 = document.querySelector(
        'input[name="hemisphere"]:checked'
      ).value;

      currentQuestion++;

      document.querySelector("#firstQuestion").style.display = "none";
      document.querySelector("#secondQuestion").style.display = "block";
    }

    if (questionNumber == "2") {
      answer2 = document.querySelector('input[name="animal"]:checked').value;

      currentQuestion++;

      document.querySelector("#secondQuestion").style.display = "none";
      document.querySelector("#thirdQuestion").style.display = "block";
    }

    if (questionNumber == "3") {
      answer3 = document.querySelector('input[name="color"]:checked').value;

      //currentQuestion++;

      document.querySelector("#thirdQuestion").style.display = "none";
      document.querySelector("#instructions").style.display = "none";
      document.querySelector("#yourResult").style.display = "block";

      document.querySelector("#firstAnswer").innerHTML = answer1;
      document.querySelector("#secondAnswer").innerHTML = answer2;
      document.querySelector("#thirdAnswer").innerHTML = answer3;

      var combinedResult = answer1 + answer2 + answer3;

      var imageName = "1";

      switch (combinedResult) {
        case "northernparrotred":
          imageName = "1";
          break;
        case "northernparrotyellow":
          imageName = "2";
          break;
        case "northernparrotgreen":
          imageName = "3";
          break;
        case "northernparrotblue":
          imageName = "4";
          break;
        case "northerndolphinred":
          imageName = "5";
          break;
        case "northerndolphinyellow":
          imageName = "6";
          break;
        case "northerndolphingreen":
          imageName = "7";
          break;
        case "northerndolphinblue":
          imageName = "8";
          break;
        case "northernspiderred":
          imageName = "9";
          break;
        case "northernspideryellow":
          imageName = "10";
          break;
        case "northernspidergreen":
          imageName = "11";
          break;
        case "northernspiderblue":
          imageName = "12";
          break;
        case "southernparrotred":
          imageName = "13";
          break;
        case "southernparrotyellow":
          imageName = "14";
          break;
        case "southernparrotgreen":
          imageName = "15";
          break;
        case "southernparrotblue":
          imageName = "16";
          break;
        case "southerndolphinred":
          imageName = "17";
          break;
        case "southerndolphinyellow":
          imageName = "18";
          break;
        case "southerndolphingreen":
          imageName = "19";
          break;
        case "southerndolphinblue":
          imageName = "20";
          break;
        case "southernspiderred":
          imageName = "21";
          break;
        case "southernspideryellow":
          imageName = "22";
          break;
        case "southernspidergreen":
          imageName = "23";
          break;
        case "southernspiderblue":
          imageName = "24";
          break;
        default:
          imageName = "1";
      } //switch

      var imageChoice = "/images/" + imageName + ".jpg";

      document.querySelector("#resultImage").src = imageChoice;
    }
  } //submitAnswer

  return (
    <>
      <h1>
        <a href='/' className='headerLink'>
          Benji Friedman's Art Quiz
        </a>
      </h1>
      <p id='instructions'>Take the quiz for a custom art result!</p>
      <hr />

      <div id='firstQuestion'>
        <h3>What hemisphere of Earth do you live in / on?</h3>
        <input type='radio' id='northern' name='hemisphere' value='northern' />
        <label>Northern Hemisphere</label>
        <br />
        <input type='radio' id='southern' name='hemisphere' value='southern' />
        <label>Southern Hemisphere</label>
        <br />
        <br />
        <input type='button' value='next' onClick={() => submitAnswer("1")} />
      </div>

      <div id='secondQuestion' style={{ display: "none" }}>
        <h3>Which animal do you prefer?</h3>
        <input type='radio' id='parrot' name='animal' value='parrot' />
        <label>Parrot</label>
        <br />
        <input type='radio' id='dolphin' name='animal' value='dolphin' />
        <label>Dolphin</label>
        <br />
        <input type='radio' id='spider' name='animal' value='spider' />
        <label>Spider</label>
        <br />
        <br />
        <input type='button' value='next' onClick={() => submitAnswer("2")} />
      </div>

      <div id='thirdQuestion' style={{ display: "none" }}>
        <h3>What color are you most into?</h3>
        <input type='radio' id='red' name='color' value='red' />
        <label>Red</label>
        <br />
        <input type='radio' id='yellow' name='color' value='yellow' />
        <label>Yellow</label>
        <br />
        <input type='radio' id='green' name='color' value='green' />
        <label>Green</label>
        <br />
        <input type='radio' id='blue' name='color' value='blue' />
        <label>Blue</label>
        <br />
        <br />
        <input type='button' value='next' onClick={() => submitAnswer("3")} />
      </div>

      <div id='yourResult' style={{ display: "none" }}>
        <p>
          You picked the <span id='firstAnswer'></span> hemisphere, a{" "}
          <span id='secondAnswer'></span>, and the color{" "}
          <span id='thirdAnswer'></span>!
        </p>

        <p>Here is an art for you!</p>

        <img id='resultImage' alt='Your art result' />

        <p>
          <a href='https://benjifriedman.com'>benjifriedman.com</a>
        </p>
      </div>
    </>
  );
}

export default App;
